import config from "../app.json";
import axios from "axios";

import { Context } from "../Reducers/Store";
import { Row, Col, Button } from "react-bootstrap";
import React, { useState, useContext, useEffect } from "react";
import FieldText from "./Fields/FieldText";
import Rectangle from "./Rectangle/rectangle";
import AlertComponent from "../Components/AlertComponent";
import { useNavigate, useLocation } from "react-router-dom";

import {
  Elements,
  useStripe,
  useElements,
  CardCvcElement,
  CardNumberElement,
  CardExpiryElement,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

const stripePromise = loadStripe(config.STRIPE);

import "../Assets/Css/index.scss";
const PaymentInfo = (props) => {
  const {
    planId,
    planDescription,
    planPrice,
    setupFee,
    totalPrice,
    showFeeInfo,
    selectPlanText = `Select your plan`,
    upgradePlan,
    updateCoupon
  } = props;
  let navigate = useNavigate();
  const [state, dispatch] = useContext(Context);
  const messageBoxDisplayClass = !planDescription ? "" : "d-none";
  const [subscriptionId, setSubscriptionId] = useState(null);

  useEffect(() => {
    if (subscriptionId) {
      handleLastPayment();
    }
  }, [subscriptionId]);

  const handleLastPayment = () => {
    axios
      .post(config.API + "/api/payment/getLastSubscriptionPayment", {
        id: subscriptionId,
      })
      .then((res) => {
        if (res.data?.status == "Error")
          return AlertComponent("Error", res.data.error, { icon: `error` });
        else if (res.data?.status == "Paid") {
          axios.post(config.API + "/api/church/getBasicChurch").then((resC) => {
            AlertComponent(
              "Success",
              !upgradePlan
                ? "All set... You'll be redirected to the Dashboard."
                : "Your plan has been updated!"
            );
            dispatch({ type: "SET_CHURCH", payload: resC.data });
            navigate("/", { replace: false });

          }).catch(function (error) {
            return AlertComponent(
              "Error",
              error?.response?.data?.error || error?.message,
              { icon: `error` }
            );
          });
        } else {
          dispatch({ type: "SET_LOADING", payload: true });
          setTimeout(() => {
            dispatch({ type: "SET_LOADING", payload: false });
            handleLastPayment();
          }, 1000);
        }
      })
      .catch(function (error) {
        return AlertComponent(
          "Error",
          error?.response?.data?.error || error?.message,
          { icon: `error` }
        );
      });
  };

  const handleCardToken = (error, token, couponCode) => {
    if (error) {
      return alert(error.message);
    } else {
      axios
        .post(config.API + "/api/payment/checkoutSubscription", {
          planId: planId,
          stripeCardToken: token.id,
          coupon: couponCode
        })
        .then((res) => {
          setSubscriptionId(res.data.stripeSubscriptionId);
        })
        .catch(function (error) {
          return AlertComponent(
            "Error",
            error?.response?.data?.error || error?.message,
            { icon: `error` }
          );
        });
    }
  };

  return (

    <div className="payment-info">
      <div className={`message-box ${messageBoxDisplayClass}`}>
        <Rectangle
          className={`button-select-your-plan`}
          title={selectPlanText}
        />
      </div>
      <h3>Payment Information</h3>
      <small>Payments handled by Stripe.</small>

      <Row>
        <Elements
          stripe={stripePromise}
          options={{ appearance: { theme: "flat" } }}
        >
          <SubmitForm
            setupFee={setupFee}
            callbackCardToken={handleCardToken}
            totalPrice={totalPrice}
            planDescription={planDescription}
            planPrice={planPrice}
            showFeeInfo={showFeeInfo}
            upgradePlan={upgradePlan}
            updateCoupon={updateCoupon}
          />
        </Elements>
      </Row>
    </div>
  );
};
export default PaymentInfo;

const SubmitForm = ({
  callbackCardToken,
  totalPrice,
  planDescription,
  planPrice,
  setupFee,
  showFeeInfo,
  upgradePlan,
  updateCoupon
}) => {
  const [state, dispatch] = useContext(Context);
  const [cardHolderName, setCardHolderName] = useState(null);
  const [cardHolderNameError, setCardHolderNameError] = useState(null);

  const [zipCode, setZipCode] = useState(null);
  const [coupon, setCoupon] = useState(null);
  const [couponData, setCouponData] = useState(null);
  const [zipCodeError, setZipCodeError] = useState(null);
  const [couponError, setCouponError] = useState(null);
  const [customSetupFee, setCustomSetupFee] = useState(setupFee);
  const [customSubscription, setCustomSubscription] = useState(planPrice);
  const [totalSetupDiscount, setTotalSetupDiscount] = useState(0);
  const [totalSubscriptionDiscount, setTotalSubscriptionDiscount] = useState(0);

  const payButtonDisplayClass = planDescription ? "" : "d-none";

  const stripe = useStripe();
  const elements = useElements({ theme: "stripe" });

  const handleSubmit = (e) => {
    e.preventDefault();
    let hasError = false;

    if (cardHolderName?.length < 2) {
      setCardHolderNameError("Card Holder Name is invalid");
      hasError = true;
    } else {
      setCardHolderNameError(null);
    }

    if (zipCode?.length < 2) {
      setZipCodeError("Zip Code is invalid");
      hasError = true;
    } else {
      setZipCodeError(null);
    }

    return !hasError;
  };

  const fetchCardToken = async (e) => {
    if (!handleSubmit(e)) {
      return;
    }

    const cardElement = elements.getElement(CardNumberElement);

    dispatch({ type: "SET_LOADING", payload: true });
    const ret = await stripe.createToken(cardElement, {
      type: "card",
    });
    dispatch({ type: "SET_LOADING", payload: false });

    callbackCardToken(ret.error, ret.token, couponData != null ? coupon : null);
  };

  const fetchValidateCoupon = () => {
    if (coupon) {
      axios.post(config.API + "/api/payment/checkCoupon", {
        code: coupon
      }).then((res) => {
        setCouponData(res.data);
        setCouponError(null);
      }).catch(function (error) {
        setCouponError(error?.response?.data?.error || error?.message);
      });
    }
  }

  const formatCurrency = (value) => {
    return Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(value);
  };

  useEffect(() => {
    if (couponData) {
      if (couponData.percentageFee) {
        setTotalSetupDiscount((setupFee * couponData.percentageFee / 100));
        setCustomSetupFee(setupFee - (setupFee * couponData.percentageFee / 100));
      }
      if (couponData.valueFee) {
        setTotalSetupDiscount(couponData.valueFee);
        setCustomSetupFee(setupFee - couponData.valueFee);
      }

      if (couponData.percentageSubscription) {
        setTotalSubscriptionDiscount((planPrice * couponData.percentageSubscription / 100));
        setCustomSubscription(planPrice - (planPrice * couponData.percentageSubscription / 100));
      }
      if (couponData.valueSubscription) {
        setTotalSubscriptionDiscount(couponData.valueSubscription);
        setCustomSubscription(planPrice - couponData.valueSubscription);
      }


    }
    else {
      setTotalSetupDiscount(0);
      setCustomSetupFee(setupFee);
      setTotalSubscriptionDiscount(0);
      setCustomSubscription(setupFee);
    }

    if (updateCoupon)
      updateCoupon(couponData);

  }, [couponData]);

  const payText = upgradePlan ? `Pay` : `Pay ${formatCurrency(totalPrice - totalSetupDiscount - totalSubscriptionDiscount)}`;
  return (
    <div name="stripe-elements">
      <Row>
        <Col className="col-md-6">
          <FieldText
            label="Cardholder Name"
            type="text"
            onChange={(x) => setCardHolderName(x.target.value)}
            placeholder="Enter the name on the card"
            value={cardHolderName}
            className="first-name-field"
            error={cardHolderNameError}
            required={true}
            inputClassName={`inputOption`}
          />
        </Col>
        <Col className="col-md-6">
          <FieldText
            label="ZIP Code"
            type="text"
            onChange={(x) => setZipCode(x.target.value)}
            placeholder="ZIP code"
            value={zipCode}
            className="first-address-field"
            error={zipCodeError}
            required={true}
            inputClassName={`inputOption`}
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-md-6">
          <div className="form-group">
            <label>Debit / Credit</label>
            <CardNumberElement
              className="stripe-input"
              options={{
                showIcon: true,
                classes: { base: "form-control" },
              }}
            />
          </div>
        </Col>
        <Col className="col-md-3">
          <div className="form-group">
            <label>Expiration</label>
            <CardExpiryElement
              className="stripe-input"
              options={{ classes: { base: "form-control" } }}
            />
          </div>
        </Col>
        <Col className="col-md-3">
          <div className="form-group">
            <label>CVC</label>
            <CardCvcElement
              className="stripe-input"
              options={{ classes: { base: "form-control" } }}
            />
          </div>
        </Col>
      </Row>
      <Row>
        <Col className="col-md-6">
          <div className="form-group">
            <FieldText
              label="Do you have a Coupon Code?"
              type="text"
              onChange={(x) => setCoupon(x.target.value)}
              placeholder="Coupon Code"
              value={coupon}
              className="first-coupon-field"
              error={couponError}
              required={true}
              inputClassName={`inputOption`}
              disabled={couponData}
            />
          </div>
          {couponData &&
            <div className="row">
              <div>
                {couponData.percentageFee && <div className="label discount">{couponData.percentageFee}% at Setup Fee</div>}
                {couponData.valueFee && <div className="label discount">{formatCurrency(couponData.valueFee)} at Setup Fee</div>}
                {couponData.percentageSubscription && <div className="label discount">{couponData.percentageSubscription}% at Subscription</div>}
                {couponData.valueSubscription && <div className="label discount">{formatCurrency(couponData.valueSubscription)} at Subscription</div>}
              </div>
            </div>}
        </Col>
        <Col className="col-md-6" style={{ display: 'flex', alignItems: 'flex-start'}}>
          {!couponData &&
            <Button
              disabled={!coupon}
              type="button"
              className={`select-plan btn btn-primary`}
              onClick={fetchValidateCoupon}
              style={{width: "100%", marginTop: 10}}
            >Apply</Button>}
          {couponData &&
              <Button
                disabled={!couponData}
                type="button"
                className={`select-plan btn btn-primary`}
                style={{width: "100%", marginTop: -30}}
                onClick={() => {
                  setCouponData(null);
                  setCouponError(null);
                }}

              >Remove Coupon</Button>

             
 }
        </Col>
      </Row>
      <Row style={{marginTop: 20}}>
        {upgradePlan && <Col className="col-md-8"></Col>}
        {!upgradePlan && (
          <Col className="col-md-8">
            <Row>
              <Col className="col-md-8 disclaimer">
                Custom mobile app for iOs and Android, built and ready for
                download + Dedicated On Demand Portal <span>(One time fee) </span>
              </Col>
              <Col className="col-md-4 payment-plan-price">
                {totalSetupDiscount > 0 && <><s>{formatCurrency(setupFee)}</s> <b>{formatCurrency(customSetupFee)}</b></>}
                {totalSetupDiscount == 0 && <b>{formatCurrency(setupFee)}</b>}
              </Col>
            </Row>
            <Row>
              <Col className="col-md-8 disclaimer">
                <p>{planDescription} Plan - Monthly Subscription</p>
              </Col>
              <Col className="col-md-4 payment-plan-price">
                {totalSubscriptionDiscount > 0 && <><s>{formatCurrency(planPrice)}</s> <b>{formatCurrency(customSubscription)}</b></>}
                {totalSubscriptionDiscount == 0 && <b>{formatCurrency(planPrice)}</b>}
              </Col>
            </Row>
          </Col>
        )}
        <Col className="col-md-4">
          <div className="pay-btn">
            <Button
              type="submit"
              className={`btn btn-success ${payButtonDisplayClass}`}
              onClick={fetchCardToken}
            >
              {payText}
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  );
};
